import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useInsurancesBehaviours} from "../api/insuranceandbehaviourapi";
import {Button} from "react-bootstrap";
import {minioBaseUrl} from "../data/defaultConfig";

export function BehaviourCodesPage(props) {
    const {insurancesBehaviours} = useInsurancesBehaviours();
    return <BasePageLayout title={'Gedrags codes'}>
        {insurancesBehaviours?.filter(i =>
           i.type === 'behaviour'
        )?.map(i => <InsuranceLink key={i?.id} insurance={i}/>)}
    </BasePageLayout>


    function InsuranceLink(props) {
        const {insurance} = props;

        return <div className={'ms-5 mt-3'}>
            <h5>{insurance.title}</h5>
            <Button className={'btn-light '} href={`${minioBaseUrl}${insurance?.fileinsurancebehavious?.url}`}
                    target={'_blank'}>Download {insurance.title}</Button>
        </div>
    }
}